import React from 'react';
import { TagSC } from './tag.styled';
import Star from '@common/components/star/star';

type TagProps = {
  name: string;
  backgroundColor: string;
  textColor: string;
  className?: string;
  onClick?: () => void;
  displayStar?: boolean;
};

const Tag: React.FunctionComponent<TagProps> = ({
  name,
  backgroundColor,
  textColor,
  className = 'tag-root',
  onClick,
  displayStar,
}) => {
  return (
    <TagSC
      backgroundColor={backgroundColor}
      textColor={textColor}
      className={className}
      onClick={onClick}
      clickable={!!onClick}
    >
      <div className={'tag'}>
        {displayStar ? <Star className={'star'} color={textColor} /> : null}
        {name}
      </div>
    </TagSC>
  );
};

export default React.memo(Tag);
